module.exports = __webpack_public_path__ + "static/img/logo1.758de01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo1.png
// module id = UCfF
// module chunks = 5